<script lang="ts">
    import {_} from 'svelte-i18n'
    import type {Session} from './types';
    import {Role} from './types';

    export let session: Session;
</script>

<span style="font-size: 0.7em;">
	{#if session.roles.includes(Role.OPERATOR)}{$_('user.Consultant')}{/if}
    {#if session.roles.includes(Role.INTERVISOR)}{$_('user.Intervisor')}{/if}
    {#if session.roles.includes(Role.ADMIN)}{$_('user.Administrator')}{/if}
</span>
